import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { BaseComponent } from '@app/components/base/base.component';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { FinancialCalculatorService } from '@app/pages/quote/open-quote/services/financial-calculator.service';
import { AuthService } from '@app/common/auth.service';
import { ResponsiveService } from '@app/services/responsive.service';
import { FinancialProductEnum } from '@app/pages/quote/standard-quote/model/standard-quote.model';

// Cambio para merge
@Component({
  template: '',
})
export class HeaderInsuranceOpenQuoteWrapper
  extends BaseComponent
  implements OnInit
{
  @Input() form: any;
  @Input() index: number;
  @Input() deal: any;
  @Input() idQuote: any;
  @Input() nameCompany: string;
  @Input() add: boolean;
  @Input() modeEditionProposal: boolean;
  @Input() userId: any;
  @Input() indexDeal: number;
  @Input() isEnabled: boolean;
  @Input() grace: any;
  @Input() isValid: boolean;
  @Input() readOnlyActions = false;

  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() update: EventEmitter<any> = new EventEmitter();
  @Output() changeModeEdition: EventEmitter<any> = new EventEmitter();
  @Output() isSelectedInsurance: EventEmitter<any> = new EventEmitter();

  indexEdit: number;
  isLoading: boolean = false;
  collapsed: boolean = true;
  readonly responsive = inject(ResponsiveService);
  readonly financialCalculator = inject(FinancialCalculatorService);
  readonly authService = inject(AuthService);

  readonly menuRef = signal<string>('');

  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }

  ngOnInit() {
    this.responsive.onListen();
  }

  updateInsurance(insurance: any) {
    this.update.emit(insurance);
  }

  editInsurance(index: number) {
    this.modeEditionProposal = !this.modeEditionProposal;
    this.add = !this.add;
    this.indexEdit = index;
    this.changeModeEdition.emit();
  }

  viewInsurance(index: number) {
    const element = document.getElementById(
      `${this.indexDeal}insurance${index}`
    ) as HTMLInputElement;
    element.classList.toggle('collapsed');
    this.collapsed = element.classList.contains('collapsed');
  }

  getId() {
    return 'menu-' + this.deal.id;
  }

  toggleMenuOptions(e: MouseEvent, updated: string = '') {
    e.preventDefault();
    this.menuRef.update((value) => (!!value ? '' : updated));
  }

  closeMenuOptions() {
    this.menuRef.set('');
  }

  getTaxFree(deal: any) {
    let taxValue = deal.taxFree || deal.taxFree == "true" ? true : false;
    if(this.nameCompany == "DTFS" && deal.financialProductType == FinancialProductEnum.directCredit) {
      taxValue = false;
    } else if(deal.financialProductType == FinancialProductEnum.financialLeasing || deal.financialProductType == FinancialProductEnum.pureLease) {
      taxValue = false;
    }
    return taxValue;
  }

  getPrice(deal: any) {
    const isPriceWithoutTax = this.getTaxFree(deal);
    if(isPriceWithoutTax) {
      return deal.unitPriceWithoutTax;
    } else {
      return deal.unitPriceWithTax;
    }
  }

  getDisaplayPrice(deal: any) {
    const isPriceWithoutTax = this.getTaxFree(deal);
    if(!isPriceWithoutTax) {
      return "Precio c/IVA";
    } else {
      return "Precio s/IVA";
    }
  }

  getTotalPrice(deal: any) {
    let downPayment = deal.downPayment;
    const isPureLease = deal.financialProductType === 'PURE_LEASING';
    let price = isPureLease ? this.getPrice(deal) : deal.unitPriceWithoutTax;
    if(isPureLease) {
      downPayment = 0;
    }
    return deal.quantity * (price - downPayment)
  }

  sendSelectedInsuranceEvent(event: any, index: number) {
    this.isSelectedInsurance.emit({ event, index });
  }
}
